function pushToDataLayer(data) {
    if (!window.dataLayer) {
        return;
    }

    window.dataLayer.push(data);
}

function trackRecirc(data) {
    pushToDataLayer({
        ...data,
        bvpEventCategory: "recirc",
        event: "bvpTrackVideo",
    });
}

function trackEngagement(data) {
    pushToDataLayer({
        ...data,
        bvpEventCategory: "engagement",
        event: "bvpTrackVideo",
    });
}

function trackScrollTracking(data) {
    pushToDataLayer({
        ...data,
        bvpEventCategory: "scroll tracking",
        event: "bvpTrackVideo",
    });
}

function trackPersonalization(data) {
    pushToDataLayer({
        ...data,
        event: "Track Request - Personalization Video PV",
    });
}

const exported = {
    push: pushToDataLayer,
    trackEngagement,
    trackScrollTracking,
    trackRecirc,
    trackPersonalization,
};

export default exported;
export {
    pushToDataLayer as push,
    trackEngagement,
    trackScrollTracking,
    trackRecirc,
    trackPersonalization,
};
